import React from "react";
import "./Inquiry.css";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Form, InputGroup } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { useForm } from "react-hook-form";
import SuccesfullModal from "../../Common_Component/SuccesfullModal/SuccesfullModal";

const Inquiry = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const { control, handleSubmit, getValues, setValue } = useForm();

  return (
    <>
      <section className="Inquiry">
        <div className="container">
          <div className="inqury-data-holder">
            <div className="inqury-main-div">
              <div className="heading">
                <h1>Ready to Elevate Your Advertising?</h1>
              </div>

              <div className="row">
                <div className="col-lg-6 col-md-12 col-sm-12 ">
                  <div className="left-card">
                    <div className="sub-heading">
                      <h1>Inquire Now!</h1>
                    </div>

                    <div className="d-flex justify-content-start align-items-start ">
                      <div className="box-holder">
                        <div className="img-main-holder">
                          <div className="img-holder">
                            <img
                              src={
                                process.env.PUBLIC_URL +
                                "/Assets/Images/Service/inquiry/bg.png"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-main-footer">
                    <div className="card-footer">
                      <div className="contact-div">
                        <div className="contact-holder">
                          <div className="icon-holder">
                            <div className="circle-div">
                              <i class="fa-solid fa-phone">
                                <FontAwesomeIcon icon={faPhone} />
                              </i>
                            </div>
                          </div>
                          <div className="info-holder">
                            <p>+91 8484024823</p>
                          </div>
                        </div>
                      </div>

                      <div className="contact-div">
                        <div className="contact-holder">
                          <div className="icon-holder">
                            <div className="circle-div">
                              <i class="fa-solid fa-phone">
                                <FontAwesomeIcon icon={faEnvelope} />
                              </i>
                            </div>
                          </div>
                          <div className="info-holder">
                            <p>info@reachoutmediatech.com</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 col-sm-12 ">
                  <div className="right-card">
                    <div className="main-form-div">
                      <div className="form">
                        <Form>
                          <div className="main-form-section mt-4">
                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Your Name"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Email"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Subject"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                {/* <Controller
                                  name="contact_no"
                                  control={control}
                                  render={({ field }) => ( */}
                                <div style={{ position: "relative" }}>
                                  <PhoneInput
                                    country={"in"}
                                    placeholder="Enter Mobile Number"
                                    value={getValues("contact_no")} // Manually bind value
                                    onChange={(phone) =>
                                      setValue("contact_no", phone)
                                    } // Manually handle change
                                    inputProps={{
                                      searchPlaceholder: "Enter Mobile Number", // Use inputProps to pass the placeholder
                                    }}
                                  />
                                </div>
                                {/*    )}
                                 /> */}
                              </Form.Group>
                            </div>

                            <div className="input-div">
                              <Form.Group>
                                <InputGroup>
                                  <Form.Control
                                    type="text"
                                    placeholder="Your Message"
                                  />
                                </InputGroup>
                              </Form.Group>
                            </div>
                            <div className="btn-div">
                              <Button
                                className="submit-btn"
                                type="button"
                                onClick={() => setModalShow(true)}
                              >
                                Send Message
                              </Button>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SuccesfullModal
        message={"Form submitted successfully !"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Inquiry;
